<div class="test-route-details-dialog">
    <div *ngIf="manipulationBeforeRouting.length > 0">
        <divider [title]="'Manipulation before route'"></divider>
        <manipulation-grid gridId="test-route-details-dialog-grid" [data]="manipulationBeforeRouting"></manipulation-grid>
    </div>
    <div *ngIf="manipulationDuringRouting.length > 0">
        <divider [title]="'Manipulation during route'"></divider>
        <manipulation-grid gridId="test-route-details-dialog-grid" [data]="manipulationDuringRouting"></manipulation-grid>
    </div>
    <ng-container *ngIf="description">
        <divider [title]="'Discard'"></divider>
        <p class="description">Description: {{description}}</p>
    </ng-container>
</div>
